/**
 * created by lei lei on 2020/6/6
 * 普通树组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Tree, Input, Checkbox} from "antd";

const {TreeNode} = Tree;
const {Search} = Input;

export default class OrdinaryTrees extends Component {
    static defaultProps = {
        showBindName: false,
        showSearch: false,
        showFoldBtn: false,
        placeholder: '请输入',
        expandedKeys: [],
        checkable:true
    }
    static propTypes = {
        dataSource: PropTypes.array.isRequired, //数据源
        checkedKeys: PropTypes.array,//默认数选中的据源
        title: PropTypes.string.isRequired,//数据源标识独特的id,不可重复
        keyId: PropTypes.string.isRequired,//数据源标识子节点key
        children: PropTypes.string.isRequired,//数据源的名称字段
        showBindName: PropTypes.bool,//是否显示另一个绑定合并名字
        bindNameKey: PropTypes.string,//与上一个属性合并使用要绑定名字的键值
        checkedKeysAll: PropTypes.func.isRequired,//组件返回的数据源
        showSearch: PropTypes.bool,//是否显示输入框搜索功能
        placeholder: PropTypes.string,//与上一个搜索框属性一块使用，自定义提示文字
        showFoldBtn: PropTypes.bool,//是否显示折叠按钮
        expandedKeys: PropTypes.array,//默认展开项,这个是点击流程图之后需要的属性，
    }

    constructor(props) {
        super(props);
        this.state = {
            expandedKeys: [],//展开的节点树
            autoExpandParent: true,
            checkedKeys: [],//选中的数据
            selectedKeys: [],//选中的文字s
            isFirst: true,
            searchText: '',
            foldStatus: false,
            allExpandedKeys: [],
            searchExpandedKeys: []
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        // if(this.state.isFirst){
        this.addNewName(this.props.dataSource)
        //  this.getFoldAllKey(this.props.dataSource)
        this.state.checkedKeys = this.state.checkedKeys.concat(this.props.checkedKeys)
        this.state.isFirst = false
        this.setState({})
        // }
    }

    componentWillReceiveProps(newProps) {
        // console.log(newProps)
        this.state.checkedKeys = newProps.checkedKeys
        if (newProps.expandedKeys.length > 0) {
            this.state.expandedKeys = newProps.expandedKeys
        }

        this.state.autoExpandParent = true //给树型结构赋值后，该属性为true后才可以展开树结构，
        this.setState({})
    }

    render() {
        this.addNewName(this.props.dataSource)
        return (
            <div>
                {this.props.showSearch ?
                    <Search style={{marginBottom: 8, width: 250, marginLeft: 10}} placeholder={this.props.placeholder}
                            onSearch={value => this.onChange(value)} enterButton
                    />
                    : null}
                {
                    this.props.showFoldBtn ?
                        <Checkbox style={{marginLeft: 10, marginTop: 5}} checked={this.state.foldStatus}
                                  onClick={() => {
                                      this.onClickFold()
                                  }
                                  }>折叠</Checkbox> : null
                }
                <Tree
                    checkable={this.props.checkable}
                    defaultExpandParent={true}
                    defaultExpandAll={true}
                    onExpand={this.onExpand}
                    expandedKeys={this.state.expandedKeys}
                    autoExpandParent={this.state.autoExpandParent}
                    onCheck={this.onCheck}
                    checkedKeys={this.state.checkedKeys}
                    onSelect={this.onSelect}
                    selectedKeys={this.state.selectedKeys}
                >
                    {this.renderTreeNodes(this.props.dataSource)}
                </Tree>
            </div>

        )
    }

    onExpand = expandedKeys => {
       // console.log('onExpand', expandedKeys);
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.setState({
            expandedKeys,
            autoExpandParent: false,//这个属性要在这里面使用fasle,不然如果子节点打开，关闭父节点关闭不了，点击没反应哦，重要操作。
        });
    };

    onCheck = (checkedKeys, info) => {
        console.log('onCheck', checkedKeys,info);
        this.props.checkedKeysAll && this.props.checkedKeysAll(checkedKeys)//把数据返回到页面里面去
        this.setState({checkedKeys});

    };

    onSelect = (selectedKeys, info) => {
       // console.log('onSelect', selectedKeys, info);
      //  this.props.checkedKeysAll && this.props.checkedKeysAll(selectedKeys)//把数据返回到页面里面去
        this.setState({selectedKeys});
    };
    onclickName(item){
        if(!this.props.checkable){
            this.props.checkedKeysAll && this.props.checkedKeysAll(item)
        }
    }

    renderTreeNodes = data =>
        data.map(item => {
            const index = this.state.searchText.length > 0 ? item.newTitle.indexOf(this.state.searchText) : -1;
            const newTitle =
                index > -1 ? (
                    <div onClick={()=>{
                        if(item[this.props.children]&&item[this.props.children].length===0){
                            this.onclickName(item)
                        }
                    }} style={{
                        width: 250,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                    }}  title={item.newTitle}>
                       <span>
                        <span style={{color: '#f50'}}>{item.newTitle}</span>
            </span>
                    </div>

                ) : (
                    <div onClick={()=>{
                        if(item[this.props.children]&&item[this.props.children].length===0){
                            this.onclickName(item)
                        }
                    }} style={{
                        width: 250,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                    }} title={item.newTitle}>
                        <span>{item.newTitle}</span>
                    </div>

                )

            if (item[this.props.children]) {
                return (
                    <TreeNode title={newTitle} key={item[this.props.keyId]} dataRef={item}>
                        {this.renderTreeNodes(item[this.props.children])}
                    </TreeNode>
                );
            }
            return <TreeNode key={item[this.props.keyId]} {...item} />;
        });

    //给树关联的数据增加新的名字需要真实树的名字和关联的流程的名字 以及折叠功能的所有展开点的数据集合
    addNewName(data) {
        let keyId = this.props.keyId
        let childKey = this.props.children
        if (data && data.length > 0) {
            data.forEach((item) => {
                //   console.log(item)
                if (this.props.showBindName) {
                    if (item[this.props.bindNameKey]) {
                        item.newTitle = ''
                        item.newTitle = item[this.props.title] + '——(' + item[this.props.bindNameKey] + ')'
                    } else {
                        item.newTitle = item[this.props.title]
                    }

                } else {
                    item.newTitle = item[this.props.title]
                }

                //获取所有的树节点开始
                if (item[childKey] && item[childKey].length > 0) {
                    this.state.allExpandedKeys.push(item[keyId])
                }
                if(!item[childKey]||item[childKey].length<1){
                    item[childKey]=[]
                }
                //获取所有的树节点结束
                // console.log(item)
                this.addNewName(item[childKey])

            })
        }
    }

    //搜索框输入变化的时候调用为提高性能，去掉了输入内容变化后调用改为点击搜索或者enter调用
    onChange(textValue) {
        if (textValue.length < 0) {
            this.state.expandedKeys = []
        }
        {
            this.state.searchExpandedKeys = []
            this.getSearchOpenKey(this.props.dataSource, textValue)
        }
        this.state.autoExpandParent = true
        this.setState({searchText: textValue, expandedKeys: this.state.searchExpandedKeys})
    }

    //点击折叠
    onClickFold() {
        if (!this.state.foldStatus) {
            this.state.expandedKeys = this.state.allExpandedKeys //数据在addNewName里面直接递归增加出来了
          //  console.log(this.state.allExpandedKeys)
        } else {
            this.state.expandedKeys = []
        }
        this.setState({foldStatus: !this.state.foldStatus})
    }

    //获取搜索搜索字段的展开树。
    getSearchOpenKey(data, searchText) {
        let keyId = this.props.keyId
        let childKey = this.props.children
        if (data && data.length > 0) {
            data.forEach((item) => {
                let index = searchText.length > 0 ? item.newTitle.indexOf(searchText) : -1;
                if (index > -1) {
                    //if(item[childKey]&&item[childKey].length>0){
                    this.state.searchExpandedKeys.push(item[keyId])
                    /* let keyIdArry=item[keyId].split('-')
                     keyIdArry.forEach((i)=>{
                        this.state.searchExpandedKeys.push(i)
                     })*/
                    // }
                }
                this.getSearchOpenKey(item[childKey], searchText)

            })
        }
    }


}